import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ChangePasswordCard() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("Les deux nouveaux mots de passe ne correspondent pas");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success(data.message);
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Modification impossible");
    } finally {
      setBusy(false);
    }
  };

  const input = "mt-1 w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-2.5 text-sm outline-none focus:border-amber-deep";
  return (
    <form data-testid="change-password-form" onSubmit={submit} className="space-y-3 rounded-2xl border border-amber-800/15 bg-white p-6 shadow-sm">
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark"><KeyRound size={18} className="text-honey" /> Changer le mot de passe</h2>
      <p className="text-sm text-bark-soft">Au moins 12 caractères, avec des lettres et des chiffres.</p>
      <label className="block text-sm font-medium text-bark">Mot de passe actuel
        <input data-testid="change-password-current" type="password" required autoComplete="current-password" value={form.current_password} onChange={set("current_password")} className={input} />
      </label>
      <label className="block text-sm font-medium text-bark">Nouveau mot de passe
        <input data-testid="change-password-new" type="password" required minLength={12} autoComplete="new-password" value={form.new_password} onChange={set("new_password")} className={input} />
      </label>
      <label className="block text-sm font-medium text-bark">Confirmer le nouveau mot de passe
        <input data-testid="change-password-confirm" type="password" required autoComplete="new-password" value={form.confirm} onChange={set("confirm")} className={input} />
      </label>
      <button data-testid="change-password-submit" disabled={busy} className="flex items-center gap-2 rounded-full bg-amber-deep px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />} Enregistrer le nouveau mot de passe
      </button>
    </form>
  );
}
